module.exports = __webpack_public_path__ + "files/a952a2fdfd09bf85d13e06d63e087ad5.png";